<div class="page-layout blank p-24" fusePerfectScrollbar>

    <h1>SAMPLE</h1>
    <h2>{{'SAMPLE.HELLO' | translate}}</h2>

</div>
